
import { Component, Vue } from "vue-property-decorator";
import { Action, Getter, Mutation, State } from "vuex-class";
import Artist from "@/models/artist";
import Artwork from "@/models/artwork";
import ScaleDisplayer from "@/components/ScaleDisplayer.vue";
import SmallScaleDisplayer from "@/components/SmallScaleDisplayer.vue";
import ColorScalesHeader from "@/components/ColorScalesHeader.vue";
import FlatLoader from "@/components/FlatLoader.vue";

const namespace = "MuseumModule";

@Component({
  components: {
    ScaleDisplayer,
    SmallScaleDisplayer,
    ColorScalesHeader,
    FlatLoader
  },
  metaInfo: {
    title: 'Color Scales',
    titleTemplate: 'Color Scales'
  }
})

export default class Museum extends Vue{
  @Action('fetchArtists', { namespace }) private fetchArtists!: () => any;
  @Action('fetchData', { namespace }) private fetchData!: () => any;
  @Getter('getArtistsSorted', { namespace }) private artistsSorted!: () => any;
  @Getter('getSortedArtworks', { namespace }) private sortedArtworks!: () => Artwork[];
  @State ("artists", { namespace }) private artists!: Artist[];
  @State ("artworks", { namespace }) private artworks!: Artwork[];
  @State ("loading", { namespace }) private loading!: boolean;
  @State ("displaying", { namespace }) private displaying!: string;
  @Mutation private setPreviousPage!: (name: string) => any;
  @Mutation private setCurrentPage!: (name: string) => any;
  @State private previousPage!: string;
  @State private currentPage!: string;

  private mounted(){
    if(this.$route.name!=null){
      this.setPreviousPage(this.currentPage);
      this.setCurrentPage(this.$route.name);
    }
  }
  
  private async created(){
    await this.fetchData();
  }

};
